import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { resetPassword, logout } from '../../store/actions/Authentication';
import ResetPasswordForm from '../../components/ResetPasswordForm/ResetPasswordForm';
import { routesAction } from '../../shared/helpers';
import Logo from '../../components/Header/Logo.svg';
import './ResetPassword.css';
import '../../components/Login/Login.css';
import yahooImage from "./yahoo.png";
import briogeoImage from "./briogeo.png";
import crowdfunderImage from "./crowdfunder.png";
import circlefixImage from "./circlefix.png";
import nikeImage from "./nike.png";
import ssImage from "./76.png";
import instyleImage from "./instyle.png";
import wavemakerImage from "./wavemaker.png";


const ResetPassword = ({ dispatchResetPassword }) => (
  <div className="page login-page">
    <div className="logo">
      <a href="https://dreamitreel.com" className="navbar-brand">
        <img alt="Dream it Reel Logo" src={Logo} />
      </a>
    </div>
    <div className="reset-password">
      <div className="reset-password__form-container">
        <ResetPasswordForm onSubmit={dispatchResetPassword} />
      </div>
    </div>
    <div className="image-container">
      <div className="content-container">
        <div className="image-container__advanced-info">
          <div className="advanced-text-info">
            <h1 className="text font-weight-bold t-40">Video creation made simple</h1>
            <ul>
              <li>A simple, streamlined process to get things started</li>
              <li>Creative talent spanning from concept to creation</li>
              <li>Next level project feedback and collaboration</li>
            </ul>
          </div>
          <div className="advanced-images">
            <div className="image-column">
              <div className="image-block">
                <img src={yahooImage} />
              </div>
              <div className="image-block">
                <img src={briogeoImage} />
              </div>
            </div>
            <div className="image-column">
              <div className="image-block">
                <img src={crowdfunderImage} />
              </div>
              <div className="image-block">
                <img src={circlefixImage} />
              </div>
            </div>
            <div className="image-column">
              <div className="image-block">
                <img src={nikeImage} />
              </div>
              <div className="image-block">
                <img src={ssImage} />
              </div>
            </div>
            <div className="image-column">
              <div className="image-block">
                <img src={instyleImage} />
              </div>
              <div className="image-block">
                <img src={wavemakerImage} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

ResetPassword.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.shape({
      split: PropTypes.func,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  dispatchResetPassword: PropTypes.func,
};

const mapStateToProps = () => ({});

const addResetPasswordToken = (data, props) => ({
  password: data.password,
  confirm_password: data.confirm_password,
  reset_password_token: props.location.search.split('=')[1],
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchResetPassword: (data, setSubmitting) => {
    const dataWithToken = addResetPasswordToken(data, ownProps);
    dispatch(resetPassword(dataWithToken)).then(action => {
      setSubmitting(false);
      if (action.type === 'RESET_PASSWORD_SUCCESS') {
        ownProps.history.push(routesAction.default());
      }
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ResetPassword));



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPassword.js